import { render, staticRenderFns } from "./BaseDetailPage.vue?vue&type=template&id=65e0fef8&scoped=true&"
import script from "./BaseDetailPage.vue?vue&type=script&lang=js&"
export * from "./BaseDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e0fef8",
  null
  
)

export default component.exports